module.exports = __webpack_public_path__ + "img/chevron-left.835e34dc.svg";